module.exports = __webpack_public_path__ + "img/k_y@2x.53fb0726.png";